module.exports = __webpack_public_path__ + "img/hand-holding-skull.b1cf3cb8.svg";